export const eventTimelineDateNameGrid = {
  border: `1px solid var(--table-header-bg)`,
  px: 1,
  borderRadius: 1,
  mt: 1,
  alignItems: 'center',
};
